import { createContext } from 'react';
import type { ServiceLocation } from '@/api/operatingHours';

/** The fail-closed load state the chooser / consumers switch on. */
export type LocationStatus = 'loading' | 'ready' | 'error';

/** The selected location, narrowed to what the chooser renders. */
export interface SelectedServiceLocation {
  id: string;
  name: string | null;
}

export interface ServiceLocationContextValue {
  /** The tenant's service locations (empty until a successful load). */
  locations: ServiceLocation[];
  /** The selected `serviceLocationId`, or null when nothing is selectable yet. */
  selectedId: string | null;
  /** The selected location (`{ id, name }`), or null when none is selected. */
  selected: SelectedServiceLocation | null;
  /** Select a location by id. A no-op for an id absent from the loaded list. */
  setSelectedId: (id: string) => void;
  /** The fail-closed load state. */
  status: LocationStatus;
  /**
   * The failure behind `status: 'error'` (DNKADM-0440), so a gated screen renders it
   * through the shared `ScreenError` (a `403` is an access answer, not a retry).
   */
  error?: unknown;
  /** Re-run the load (the chooser's Retry on `error`). */
  retry: () => void;
}

export const ServiceLocationContext = createContext<ServiceLocationContextValue | null>(null);
